module.exports = __webpack_public_path__ + "img/process-xs.dd30bf04.png";